var React = require('react');

function MobileIcon (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("clipPath",{"id":"mobile-icon_svg__a"},React.createElement("path",{"fill":"#10457a","d":"M0 0h17.46v32H0z","data-name":"Rectangle 221"}))),React.createElement("g",{"clipPath":"url(#mobile-icon_svg__a)","data-name":"Group 1212","key":1},React.createElement("path",{"fill":"#10457a","fillRule":"evenodd","d":"M14.778 0H2.683A2.691 2.691 0 0 0 0 2.683v26.634A2.691 2.691 0 0 0 2.683 32h12.095a2.691 2.691 0 0 0 2.683-2.683V2.683A2.691 2.691 0 0 0 14.778 0M6.947 2.35h3.565a.383.383 0 1 1 0 .767H6.947a.383.383 0 1 1 0-.767m2.976 27.883H7.538a.86.86 0 0 1 0-1.719h2.385a.86.86 0 0 1 0 1.719m5.78-2.789H1.758V4.556H15.7Z","data-name":"Path 405"}))]);
}

MobileIcon.defaultProps = {"width":"17.46","height":"32","data-name":"Group 1213"};

module.exports = MobileIcon;

MobileIcon.default = MobileIcon;
